import { Breakpoints, styled } from '@vw-marketing/us-components';

export const RootWrapper: any = styled.div`
  position: relative;
`;

export const CardWrapper: any = styled.div`
  ${({ theme, isSalesEvent }) => {
    return `
      ${!isSalesEvent ? `align-items: flex-start;` : `align-items: center;`}
      background: ${theme.colors.gradient.top};
      position: relative;
      color: white;
      display: flex;
      height: auto;
      flex-direction: column;
      width: ${theme.size.grid024}; 
      padding: ${theme.size.dynamic0150} ${theme.size.grid002};
      align-items: center;

      
      
      @media (min-width: ${Breakpoints.b560}px) {
        /*padding: ${theme.size.dynamic0150} 94px; */
        padding: ${theme.size.dynamic0150} ${theme.size.grid004};
        justify-content: center;
       
      }

      @media (min-width: ${Breakpoints.b960}px) {
        /*gap: 40px;*/
        gap: ${theme.size.grid001};
        /*padding: ${theme.size.dynamic0150} 40px;*/
        padding: ${theme.size.dynamic0150} ${theme.size.grid001};
        flex-direction:row;
        align-items: flex-start;
      }
      
      @media (min-width: ${Breakpoints.b1280}px) {
        gap: 54px;
        padding: ${theme.size.dynamic0130} 54px;
        width: ${theme.size.grid022}; 
      }

      @media (min-width: ${Breakpoints.b1600}px) {
        gap: 67px;
        padding: ${theme.size.dynamic0130} 67px;
      }
    `;
  }}
`;

export const ContentWrapper: any = styled.div`
  ${({ theme }) => {
    return `
      @media (min-width: ${Breakpoints.b960}px) {
        width: ${theme.size.grid017};
      }
      @media (min-width: ${Breakpoints.b1280}px) {
        width: ${theme.size.grid015};
      }
    `;
  }}
`;

export const OfferConditionsWrapper: any = styled.div`
  ${({ theme }) => {
    return `
      display: flex;
      flex-direction: column;

      @media (min-width: ${Breakpoints.b960}px) {
        width: ${theme.size.grid008};

      }

      @media (min-width: ${Breakpoints.b1280}px) {
        width: ${theme.size.grid006};

      }
`;
  }}
`;

export const OfferContentWrapper: any = styled.div`
  ${({ theme }) => {
    return `
      display: flex;
      flex-direction: column;
      align-items: flex-start;

      @media (min-width: ${Breakpoints.b960}px) {
        width: ${theme.size.grid008};

      }
`;
  }}
`;

export const SecondayColorTextWrapper: any = styled.span`
  color: #dfe4e8;
`;

export const MainContentWrapper: any = styled.div`
  ${({ theme }) => {
    return `
    display: flex;
    gap: 0px;
    align-self: stretch;
    align-items: flex-start;
    flex-direction: column;

    @media (min-width: ${Breakpoints.b960}px) {
        flex-direction: row;
        /*gap: 40px;*/
        gap: ${theme.size.grid001};
    }

    @media (min-width: ${Breakpoints.b1280}px) {
        gap: 54px;
        
    }

    @media (min-width: ${Breakpoints.b1600}px) {
        gap: 67px;
    }
  `;
  }}
`;

export const PaymentSectionWrapper: any = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding-bottom: 24px;
  gap: 4px;
`;

export const PaymentContentWrapper: any = styled.div`
  ${({ theme, isAprSalesEvent }) => {
    return `
    display: flex;
    ${
      !isAprSalesEvent
        ? `gap: ${theme.size.dynamic0020};`
        : `gap: ${theme.size.dynamic0100};`
    }
    align-self: stretch;
    align-items: flex-start;
    ${!isAprSalesEvent ? `flex-direction: column;` : ``}
    @media (min-width: 375px) {
        flex-direction:row;
        gap: ${theme.size.dynamic0100};
    }
  `;
  }}
`;

export const ClockIconWrapper: any = styled.div`
  @media (min-width: ${Breakpoints.b1600}px) {
    padding-bottom: 3px;
  }
`;

export const ColumnContentWrapper: any = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const NumericContentWrapper: any = styled.div`
  ${({ theme }) => {
    return `
    display: flex;
    gap: ${theme.size.static100};
    align-items: flex-end;
  `;
  }}
`;

export const NumericDataWrapper: any = styled.div`
  display: flex;
  align-items: flex-start;
`;

export const HighlightContentWrapper: any = styled.div`
  display: flex;
  gap: 4px;
  align-self: stretch;
  align-items: flex-start;

  @media (min-width: ${Breakpoints.b960}px) {
    gap: 8px;
  }
`;

export const BadgeIconWrapper: any = styled.div``;

export const DateContentWrapper: any = styled.div`
  display: flex;
  gap: 8px;
  padding-bottom: 12px;
  align-self: stretch;
  align-items: center;
`;

export const OtherOfferTypeContentWrapper: any = styled.div`
  ${({ theme }) => {
    return `
    display: flex;
    padding-bottom: ${theme.size.static200};
`;
  }}
`;

export const OfferDescription: any = styled.div`
  display: flex;
  align-items: flex-start;
  align-self: stretch;
  max-width: 267px;
  padding-bottom: 6px;

  @media (min-width: 375px) {
    max-width: 322px;
  }

  @media (min-width: ${Breakpoints.b560}px) {
    max-width: 374px;
    padding-bottom: 4px;
  }
  @media (min-width: ${Breakpoints.b960}px) {
    max-width: 320px;
  }
  @media (min-width: ${Breakpoints.b1280}px) {
    max-width: 450px;
  }
  @media (min-width: ${Breakpoints.b1600}px) {
    padding-bottom: 8px;
    max-width: 535px;
  }
`;

export const ButtonsContainer: any = styled.div`
  ${({ theme }) => {
    return `
  display: flex;
  align-items: center;
  gap: ${theme.size.static300};
  padding-top: ${theme.size.dynamic0100};
  align-self: stretch;
  flex-direction: column;

  @media (min-width: ${Breakpoints.b960}px) {
    flex-direction: row;
  }
  `;
  }}
`;

export const ViewOffersButton: any = styled.div`
  ${({ theme }) => {
    return `
     button:hover {
      background: ${theme.colors.accent.nbab.default};
      color: rgb(0, 30, 80);
      
    }

    button {
      &:active,
      &:focus {
        background: ${theme.colors.accent.offer.default} !important;
        color: rgb(0, 30, 80) !important;
     }
      min-height: ${theme.size.static400};
      @media (min-width: ${Breakpoints.b960}px) {
        min-height: 44px;
      }
    }

    `;
  }}
`;

export const ViewInventoryButton: any = styled.div`
  ${({ theme }) => {
    return `
   a:hover {
        color: ${theme.colors.accent.nbab.default};
      }

      a {
        color: white;
      }
  `;
  }}
`;

export const StyledDisclaimerContainer: any = styled.div`
  ${() => {
    return `
      .disclaimer-modal-container {
        z-index: 9999;
        position: absolute;
      }

      .disclaimer-text-container {
        width: 100%;
      }
    `;
  }}
`;
